import {
  TCustomizedMetric,
  TMetricDataRow,
  TMetricQueryParams
} from 'types/GlobalMetric'
import { TGroup } from 'types/GlobalGroup'
import { PeriodFilter } from 'types/GlobalWidget'
import { TDashboardGroupResponse } from 'types/GlobalDashboardGroup'
import { TReport } from 'types/GlobalReport'
import { TResourceVariant } from 'types/GlobalResource'

type TKeyMetricBase = {
  id: string
  index: number
  title: string
  metric: TCustomizedMetric
  // The underlying metric's entity (scopes column editing / AI-column
  // highlighting); null when the key metric has no entity.
  entity_id: string | null
}

export type UpdateKeyMetricOrderItem = {
  id: string
  index: number
  children?: UpdateKeyMetricOrderItem[]
}

export type TKeyMetricResource = {
  resource_id: string
  resource_type: TResourceVariant
}

export type TKeyMetricApi = TKeyMetricBase & {
  children: TKeyMetricApi[]
  group_ids: string[]
  increase_is_positive: boolean
  parent: string | null
  pin_comment: string | null
  pin_id: string | null
  pinned: boolean
  resources: TKeyMetricResource[]
  responsible_account_id: string | null
  target_activated: boolean
  target_value: number | null
}

export type TKeyMetric = TKeyMetricBase & {
  children: TKeyMetric[]
  groups: Omit<TGroup, 'key_metrics'>[] // avoid circular dependency
  increase_is_positive: boolean
  parent: TKeyMetricBase | null
  pin_comment: string | null
  pin_id: string | null
  pinned: boolean
  resources: (TDashboardGroupResponse | TReport)[]
  responsible_account_id: string | null
  target_activated: boolean
  target_value: number | null
}

export type TKeyMetricDataBody = {
  period_filter?: PeriodFilter
  query_params?: TMetricQueryParams
}

export type TKeyMetricRawData = {
  data: TMetricDataRow[]
  key_figure?: { value: number | null }
  segment_attribute_option_id: string | null
  target: TMetricDataRow[] | null
}

export function isDashboardResource(
  resource: TDashboardGroupResponse | TReport
): resource is TDashboardGroupResponse {
  return 'dashboards' in resource
}

export function getResourceVariant(
  resource: TDashboardGroupResponse | TReport
): TResourceVariant {
  return isDashboardResource(resource) ? 'dashboard' : 'report'
}
